import { SiteSpecificComponentContext } from '@orgnc/core/lib/themes/SiteSpecificComponentsProvider';
import MUIThemeProvider from '@orgnc/core/components/organisms/MUIThemeProvider';
import { openSans, merriWeather } from '../utils/localFonts';
import theme from '../theme';

const StaticApp: React.FunctionComponent<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <>
      <style jsx global>{`
        html {
          font-family: ${openSans.style.fontFamily};
          font-family: ${merriWeather.style.fontFamily};
        }
        html,
        body {
          margin: 0;
          padding: 0;
        }
      `}</style>
      <SiteSpecificComponentContext.Provider value={theme}>
        <MUIThemeProvider>{children}</MUIThemeProvider>
      </SiteSpecificComponentContext.Provider>
    </>
  );
};

export default StaticApp;
